import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getEntries, getSearch, getFilters, getSettings } from '../../common/services/selectors';
import Pager from '../../common/components/_Pager';
import TWICLCompaniesSearchItem from './TWICLCompaniesSearchItem';
import SearchInput from '../../common/components/_SearchBox';
//import TWICLCompaniesDropdown from './TWICLCompaniesFilterDropdown';



function TWICLCompanies({ entries, search, settings }) { 

    const { items = [] } = entries || {};

    var displaySearchResults = false;

    if (search.term && search.term != '')
    {
        displaySearchResults = true;
    }

    if (search.certificationtype && search.certificationtype != '')
    {
        displaySearchResults = true;
    }



	return (
        <div> 
            <div className="row column">
                <div className="filter-bar faq large-12">
                    <div className="filter__text">
                        Company Search
                    </div>

                    <SearchInput search={search} settings={settings}/>	 

                </div>
                
            </div>
            { displaySearchResults &&
                <span>
                    <div className="row">
                        <div className="large-12 column">
                            <h1 className="search-title">Search results</h1>
                            { search && search.term && <p className="search-keyword">{entries.totalCount} result(s) found for <strong>{ search.term && search.term}</strong></p>}

                        </div>
                    </div>

                    <p></p>


                    <div className="row">

                        <div className="column large-9">
                            <div className="row">
                                <div className="large-12 column">
                                    {entries.totalCount === 0 && <p>Nothing Found</p>}
                                    {entries.totalCount > 0 && 
                                        items.map((entry, index) => <TWICLCompaniesSearchItem key={entry.sys.id} entry={entry} index={index} settings={settings} />) }
                                </div>
                            </div>
                            {entries.totalCount > 10 && <Pager entries={entries} search={search} settings={settings} />}
                        </div>
                    </div>


                </span>}
            

        </div>
	);
}

TWICLCompanies.propTypes = {
    entries: PropTypes.object,
    search: PropTypes.object,
    filters: PropTypes.object, 
    settings: PropTypes.object
};

const mapStateToProps = state => ({ entries: getEntries(state), search: getSearch(state), filters: getFilters(state), settings: getSettings(state) });

export default connect(mapStateToProps)(TWICLCompanies);